import React from 'react'
import styles from './AlertLabel.module.css'

const AlertLabel = ({ message }) => {
    return (
        <div className={styles["warning-container"]}>
            <div className={styles["warning-icon-container"]}>
                <div className={styles["warning-icon"]}>!</div>
            </div>
            <div className={styles["warning-message"]}>{message}</div>
        </div>
    )
}

export default AlertLabel